import React from 'react';
import { View, Pressable, ViewStyle } from 'react-native';
import {ToolbarProps} from 'react-big-calendar';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { EventType } from '../../../../api/DemandeAbsence/types';
import { stdCouleurBleu } from '@commonStyle';
import { TooltipWrapper } from '../../../TooltipWrapper';
import styles from '../../CalendrierUniversel.styles';

type Props = {
  buttonStyle: ViewStyle,
  buttonSize: number
}

export default function FragmentToolbarNavigation(props: ToolbarProps<EventType> & Props) {
  const {buttonStyle, buttonSize, onNavigate} = props;
  const width = `${100/3}%`;

  return(
    <View style={[styles.buttonList, styles.flex]}>
      <Pressable style={{width}} onPress={() => onNavigate('PREV')} testID='BT_PREVIOUS'>
        <TooltipWrapper style={{...buttonStyle}} tooltip="Précedent">
            <Icon name="chevron-left" color={stdCouleurBleu} size={buttonSize} />
        </TooltipWrapper>
      </Pressable>
      <Pressable style={{width}} onPress={() => onNavigate('TODAY')} testID='BT_TODAY'>
        <TooltipWrapper style={{...buttonStyle}} tooltip="Aujourd'hui">
          <Icon name="calendar-refresh" color={stdCouleurBleu} size={buttonSize} />
        </TooltipWrapper>
      </Pressable>
      <Pressable style={{width}} onPress={() => onNavigate('NEXT')} testID='BT_NEXT'>
        <TooltipWrapper style={{...buttonStyle}} tooltip="Suivant">
          <Icon name="chevron-right" color={stdCouleurBleu} size={buttonSize} />
        </TooltipWrapper>
      </Pressable>
    </View>
  )
}
